export default __webpack_public_path__ + "static/media/logokickave_loop.0ddfdb24.gif";